import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import endpoints from '../../config/endpoints';
import { Sidebar } from '../../layouts/Sidebar';
import { setLoading } from '../../services/reducers/homeSlice';
import restApi from '../../services/restApi';
import tools from '../../utils/tools';

const DeliveryMethodManage = () => {
  const { id: paramId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form, setForm] = useState<any>({});
  const [boxes, setBoxes] = useState<any[]>([]);
  const isTapin = form.provider === 'tapin';

  const send = async () => {
    dispatch(setLoading(true));

    const res = await restApi(endpoints.deliveryMethod.basic + (paramId || '')).post(tools.extractor(form, ['title', 'price', 'description', 'provider', 'tapinOrderType', 'tapinBoxId']));

    if (res.code == 200) {
      Swal.fire({
        title: 'موفق',
        text: `نحوه ارسال با موفقیت ${paramId ? 'ویرایش' : 'ایجاد'} شد`,
        icon: 'success',
        confirmButtonText: 'متوجه شدم',
        didClose() {
          navigate('/deliveryMethod')
        }
      });
    } else {
      Swal.fire({
        title: 'ناموفق',
        text: res?.data,
        icon: 'error',
        confirmButtonText: 'متوجه شدم'
      });
    }

    dispatch(setLoading(false));
  };

  const fetchItem = async () => {
    dispatch(setLoading(true));

    const res = await restApi(endpoints.deliveryMethod.single + paramId, true).get();

    if (res.code == 200) {
      setForm({
        title: res.data?.title,
        price: res.data?.price,
        description: res.data?.description,
        provider: res.data?.provider || '',
        tapinOrderType: res.data?.tapinOrderType ?? '',
        tapinBoxId: res.data?.tapinBoxId ?? ''
      });

    }

    dispatch(setLoading(false));
  };

  const fetchBoxes = async () => {
    const res = await restApi(endpoints.tapin.boxes, true).get();

    setBoxes(res.code == 200 ? res.data?.list || [] : []);
  };

  useEffect(() => {
    paramId && fetchItem();
  }, []);

  useEffect(() => {
    isTapin && boxes.length == 0 && fetchBoxes();
  }, [isTapin]);

  return (
    <>
      <body className="dashboardBody">
      <Sidebar/>
      <main className="dashBoardMain main">
        <div className="addInfoHeader">
          <span className="dashboardHeader keepRight clickable" onClick={send}>
           {paramId ? 'ویرایش ' : 'ایجاد '}نحوه ارسال
          </span>
          <span>
            <h1 className="sideBarTitle">بازگشت به صفحه نحوه ارسال</h1>
             <h1 className="dashBoardTitle">{paramId ? 'ویرایش' : 'ایجاد'} نحوه ارسال </h1>
          </span>
          <i className="backAdd clickable" onClick={() => navigate('/deliveryMethod/')}></i>
        </div>
        <section className="bottomSection">
          <h1 className="dashBoardTitle">اطلاعات نحوه ارسال</h1>
          <form className="addInfo">
            <label className="sideBarTitle" htmlFor="infoTitle">عنوان</label>
            <input className="addInput" id="infoTitle" onChange={(input: any) => setForm(prev => ({
              ...prev,
              title: input.target.value
            }))} value={form.title}/>
            <label className="sideBarTitle" htmlFor="infoTitle">قیمت</label>
            <input className="addInput" id="infoTitle" onChange={(input: any) => setForm(prev => ({
              ...prev,
              price: input.target.value
            }))} value={form.price}/>
            <label className="sideBarTitle" htmlFor="infoProvider">سرویس ارسال</label>
            <select className="addInput" id="infoProvider" onChange={(input: any) => setForm(prev => ({
              ...prev,
              provider: input.target.value
            }))} value={form.provider || ''}>
              <option value="">قیمت ثابت</option>
              <option value="tapin">تاپین (پست)</option>
            </select>
            {isTapin &&
              <>
                <label className="sideBarTitle" htmlFor="infoOrderType">نوع سرویس تاپین</label>
                <select className="addInput" id="infoOrderType" onChange={(input: any) => setForm(prev => ({
                  ...prev,
                  tapinOrderType: input.target.value
                }))} value={form.tapinOrderType ?? ''}>
                  <option value={1}>پیشتاز</option>
                  <option value={0}>سفارشی</option>
                  <option value={3}>ویژه</option>
                </select>
                <label className="sideBarTitle" htmlFor="infoBox">بسته بندی</label>
                <select className="addInput" id="infoBox" onChange={(input: any) => setForm(prev => ({
                  ...prev,
                  tapinBoxId: input.target.value
                }))} value={form.tapinBoxId ?? ''}>
                  <option value="">پیش فرض</option>
                  {boxes.map(box => <option key={box.pk} value={box.pk}>{box.title}</option>)}
                </select>
                <small>هزینه ارسال این روش در زمان تسویه به صورت آنلاین از تاپین استعلام میشود و قیمت ثابت بالا نادیده گرفته میشود. در صورت عدم دسترسی به تاپین، انتخاب این روش برای مشتری ممکن نخواهد بود.</small>
              </>
            }
            <label className="sideBarTitle" htmlFor="infoAmount">توضیحات</label>
            <textarea className="addInput" placeholder="توضیحات" id="infoAmount" onChange={(input: any) => setForm((prev) => {
              return {
                ...prev,
                description: input.target.value
              };
            })} value={form.description}/>
          </form>
        </section>
      </main>
      </body>
    </>
  );
};
export default DeliveryMethodManage;